<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>信息查询</el-breadcrumb-item>
      <el-breadcrumb-item>作品排名</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="min-width:360px; margin-right: 20px;">
          <el-select
            v-model="queryInfo.MatchID"
            placeholder="请选择赛项名称"
            clearable
            @change="selectGettrack(queryInfo.MatchID, 0)"
            style="min-width:360px"
          >
            <el-option
              v-for="item in matchNameoptions"
              :key="item.MatchID"
              :label="item.MatchName"
              :value="item.MatchID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="margin-right:160px;">
          <el-select
            v-model="queryInfo.TrackID"
            placeholder="请选择赛道"
            clearable
            style="width:360px !important;"
          >
            <el-option
              v-for="item in trackNameoptions"
              :key="item.TrackID"
              :label="item.TrackName"
              :value="item.TrackID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
            placeholder="请输入作品名称"
            v-model="queryInfo.EntriesName"
            clearable
          >
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getRankingList(1)"
            >搜索</el-button
          >
        </el-col>
        <el-col :span="1">
          <el-button icon="el-icon-download" type="success" @click="doDown"
            >导出</el-button
          >
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="SerialNumber" label="作品排名" width="70">
        </el-table-column>
        <el-table-column prop="FinalScore" label="作品得分" width="70">
        </el-table-column>
        <el-table-column prop="EntriesStatus" label="评分状态" width="70">
          <template slot-scope="scope">
            <div>
              {{ scope.row.EntriesStatus === 0 ? '未评分' : '已评分' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="EntriesName" label="作品名称"> </el-table-column>
        <el-table-column prop="ItemNo" label="作品编号" width="120"> </el-table-column>
        <el-table-column prop="TrackName" label="赛道"> </el-table-column>
        <el-table-column prop="LeadCadName" label="负责人姓名" width="90">
        </el-table-column>
        <!-- <el-table-column prop="Gender" label="性别" width="50">
        </el-table-column> -->
        <el-table-column prop="CellPhoneNum" label="手机号" width="100"> </el-table-column>
        <el-table-column prop="School" label="所属学校" width="150"> </el-table-column>
        <el-table-column prop="Departments" label="学校院系"> </el-table-column>
        <el-table-column
          prop="SubDate"
          label="提交日期"
          :formatter="dataFormat"
          width="150"
        >
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        // 赛项名称
        matchName: '',
        // 赛道名称
        trackName: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ],
      // 赛道下拉选项
      trackNameoptions: [
        {
          value: '1',
          label: '赛道1'
        },
        {
          value: '2',
          label: '赛道2'
        }
      ],
      // 专业领域下拉选项
      fieldOptions: [
        {
          value: '1',
          label: '张三'
        },
        {
          value: '2',
          label: '李四'
        }
      ],
      // 分组
      groupOptions: []
    }
  },
  created() {
    // 默认获取赛事
    this.getAllMatch()
  },
  methods: {
    //   获取列表
    async getRankingList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/Entries/GetEntriesRanking',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.entries
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
      this.matchNameoptions1 = res.Data.matchs
      this.matchNameoptions2 = res.Data.matchs
      // 默认选中第一项
      this.queryInfo.MatchID = this.matchNameoptions[0].MatchID
      // 加载第一项赛道信息
      this.selectGettrack(this.queryInfo.MatchID, 0)
      //   默认获取列表
      this.getRankingList(1)
    },
    // 下拉赛项获取对应赛道
    // selectType 0搜索 1 添加 2修改
    async selectGettrack(id, selectType) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      if (selectType === 0) {
        this.$set(this.queryInfo, 'TrackID', null)
        this.trackNameoptions = res.Data.tracks
      } else if (selectType === 1) {
        this.trackNameoptions1 = res.Data.tracks
      } else if (selectType === 2) {
        this.trackNameoptions2 = res.Data.tracks
      }
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getRankingList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getRankingList(newPage)
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    // 导出
    doDown() {
      this.$http
        .get('/api/Entries/ExportEntriesRanking', { params: this.queryInfo })
        .then((res) => {
          const a = document.createElement('a')
          const href = res.data.Data
          a.href = href
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.el-col {
  width: 14% !important;
}
.filename {
  text-decoration: none;
  color: #333;
}
</style>
